import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Menu from '../myComponents/Menu';
import './SetupPlatformPage.css';
import Footer from '../myComponents/Footer';

const SetupLinuxPage = () => {
 const [activeIndex, setActiveIndex] = useState(null);
 const [activeTab, setActiveTab] = useState(0);

 const toggleSection = (index) => {
   setActiveIndex(activeIndex === index ? null : index);
 };

 return (
   <div className="App">
     <div style={{ position: 'relative', zIndex: 1000 }}>
       <Menu />
     </div>
     
     <section className="platform-setup-section">
       <div className="platform-container">
         {/* Header */}
         <div className="platform-header">
           <div className="platform-breadcrumb">
             <Link to="/setup">
               ← Все инструкции
             </Link>
           </div>
           <h1 className="platform-title">Как установить VPN на Linux</h1>
           <p className="platform-description">
             RED BUTTON предлагает несколько способов для подключения к VPN на Linux системах. <br/><br/>
             Мы рекомендуем современное приложение INCY — простой графический интерфейс, поддержка всех популярных дистрибутивов.
           </p>
         </div>

         {/* App Tabs */}
         <div className="app-tabs">
           <div
             className={`tab ${activeTab === 0 ? 'active' : ''}`}
             onClick={() => setActiveTab(0)}
           >
             ⚡ INCY
           </div>
           <div
             className={`tab ${activeTab === 1 ? 'active' : ''}`}
             onClick={() => setActiveTab(1)}
           >
             Hiddify
           </div>
           <div
             className={`tab ${activeTab === 2 ? 'active' : ''}`}
             onClick={() => setActiveTab(2)}
           >
             V2RayA
           </div>
         </div>

         {/* Setup Steps */}
         <div className="setup-steps">
           
           {/* INCY Tab */}
           {activeTab === 0 && (
             <>
               <div className="tab-text-content">
                 <p>INCY — современный VPN-клиент для Linux. Поддерживает все популярные дистрибутивы (Ubuntu, Debian, Arch, Fedora и др.). Работает в режиме TUN, поэтому весь системный трафик проходит через VPN автоматически.</p>

                 <h1>⚡ Установка INCY</h1>
                 <p>Скачайте установщик INCY для Linux с официального GitHub репозитория. Доступны deb, rpm и AppImage пакеты.</p>

                 <div className="section-button">
                   <a href="https://github.com/INCY-DEV/incy-platforms/releases/latest" target="_blank" rel="noopener noreferrer">
                       <button className="download-btn">
                       Скачать INCY для Linux
                       </button>
                   </a>
                 </div>

                 <h1>Получение ключа</h1>
                 <p>После активации VPN скопируйте Subscription link, который прислал Telegram-бот или который виден в личном кабинете на сайте.</p>
               </div>

               <div className="setup-section">
                 <button
                   className={`section-header ${activeIndex === 0 ? 'active' : ''}`}
                   onClick={() => toggleSection(0)}
                 >
                   <h3>Получение ключа в личном кабинете</h3>
                   <span className="section-icon">
                     {activeIndex === 0 ? '−' : '+'}
                   </span>
                 </button>

                 <div className={`section-content ${activeIndex === 0 ? 'active' : ''}`}>
                   <div className="section-content-inner">
                     <ol className="steps-list">
                       <li>Войдите в Telegram-бот или в личный кабинет на сайте</li>
                       <li>Сразу после оплаты вы получите Subscription Link</li>
                       <li>В боте: раздел «Мои конфигурации» → «Общая подписка»</li>
                       <li>Кликните один раз на ссылку, чтобы скопировать</li>
                       <li>Также можно использовать QR-код</li>
                     </ol>
                     <div className="step-screenshot">
                       <img src="/assets/get_link.jpg" alt="Скриншот: Получение ключа" />
                     </div>
                   </div>
                 </div>
               </div>

               <div className="tab-text-content">
                 <h1>Подключение VPN</h1>
                 <p>Запустите INCY. Нажмите «+» или «Добавить подписку», вставьте скопированный Subscription Link. Приложение автоматически подгрузит список серверов. Выберите сервер и нажмите кнопку подключения.</p>
                 <p>Готово! Весь системный трафик идёт через VPN. Подписка обновляется автоматически. ⚡</p>
               </div>
             </>
           )}

           {/* Hiddify Tab */}
           {activeTab === 1 && (
             <>
               <div className="tab-text-content">
                 <p>Для настройки RED BUTTON на Linux системах рекомендуем использовать Hiddify - простое приложение с графическим интерфейсом для всех популярных дистрибутивов.</p>
                 
                 <h1>Установка Hiddify</h1>
                 <p>Скачайте Hiddify для вашего дистрибутива Linux. Поддерживаются Ubuntu, Debian, Arch, Fedora и другие дистрибутивы.</p>
                 
                 <div className="section-button">
                   <a href="https://github.com/hiddify/hiddify-next/releases" target="_blank" rel="noopener noreferrer">
                       <button className="download-btn">
                       Скачать Hiddify
                       </button>
                   </a>
                 </div>
                 
                 <h1>Получение ключа</h1>
                 <p>После активации VPN скопируйте Subscription link, который прислал Telegram-бот.</p>
               </div>

               <div className="setup-section">
                 <button
                   className={`section-header ${activeIndex === 0 ? 'active' : ''}`}
                   onClick={() => toggleSection(0)}
                 >
                   <h3>Получение ключа в личном кабинете</h3>
                   <span className="section-icon">
                     {activeIndex === 0 ? '−' : '+'}
                   </span>
                 </button>
                 
                 <div className={`section-content ${activeIndex === 0 ? 'active' : ''}`}>
                   <div className="section-content-inner">
                     <ol className="steps-list">
                       <li>Войдите в Telegram Бот</li>
                       <li>Сразу после оплаты бот прислал вам Subscription Link</li>
                       <li>Перейдите в раздел 'Мои конфигурации'</li>
                       <li>Откройте 'Общая подписка'</li>
                       <li>Кликните один раз на ссылку, чтобы ее скопировать</li>
                       <li>Вы также можете воспользоваться QR кодом</li>
                     </ol>
                     <div className="step-screenshot">
                       <img src="/assets/get_link.jpg" alt="Скриншот: Получение ключа" />
                     </div>
                   </div>
                 </div>
               </div>

               <div className="setup-section">
                 <button
                   className={`section-header ${activeIndex === 1 ? 'active' : ''}`}
                   onClick={() => toggleSection(1)}
                 >
                   <h3>Установка на Ubuntu/Debian</h3>
                   <span className="section-icon">
                     {activeIndex === 1 ? '−' : '+'}
                   </span>
                 </button>
                 
                 <div className={`section-content ${activeIndex === 1 ? 'active' : ''}`}>
                   <div className="section-content-inner">
                     <ol className="steps-list">
                       <li>Скачайте .deb пакет Hiddify с GitHub</li>
                       <li>Откройте терминал и перейдите в папку Downloads</li>
                       <li>Установите пакет: sudo dpkg -i hiddify*.deb</li>
                       <li>Если есть зависимости: sudo apt-get install -f</li>
                       <li>Запустите Hiddify из меню приложений</li>
                       <li>Нажмите "+" и вставьте subscription-ссылку</li>
                       <li>Выберите сервер и подключитесь</li>
                     </ol>
                   </div>
                 </div>
               </div>

               <div className="tab-text-content">
                 <h1>Важные настройки Hiddify</h1>
                 <p>В настройках обязательно выберите регион "Россия" для обхода только заблокированных сайтов или "Другой" для полного VPN. Включите "Автоподключение" для автоматического запуска при загрузке системы.</p>
                 <p>В разделе "DNS" установите Cloudflare (1.1.1.1) или Google DNS (8.8.8.8) для обхода блокировок провайдера.</p>
                 <p>Готово! Hiddify обеспечивает простую настройку на любом Linux дистрибутиве. 🔒</p>
               </div>
             </>
           )}

           {/* V2RayA Tab */}
           {activeTab === 2 && (
             <>
               <div className="tab-text-content">
                 <p>V2RayA - современное решение для Linux с веб-интерфейсом. Управляется через браузер, работает как системный сервис. Идеально для серверов и продвинутых пользователей.</p>
                 
                 <h1>Установка V2RayA</h1>
                 <p>V2RayA работает как сервис с веб-интерфейсом. Поддерживает все основные дистрибутивы Linux.</p>
                 
                 <div className="section-button">
                   <a href="https://github.com/v2rayA/v2rayA/releases" target="_blank" rel="noopener noreferrer">
                       <button className="download-btn">
                       Скачать V2RayA
                       </button>
                   </a>
                 </div>
                 
                 <h1>Получение ключа</h1>
                 <p>После активации VPN скопируйте Subscription link, который прислал Telegram-бот.</p>
               </div>

               <div className="setup-section">
                 <button
                   className={`section-header ${activeIndex === 0 ? 'active' : ''}`}
                   onClick={() => toggleSection(0)}
                 >
                   <h3>Получение ключа в личном кабинете</h3>
                   <span className="section-icon">
                     {activeIndex === 0 ? '−' : '+'}
                   </span>
                 </button>
                 
                 <div className={`section-content ${activeIndex === 0 ? 'active' : ''}`}>
                   <div className="section-content-inner">
                     <ol className="steps-list">
                       <li>Войдите в Telegram Бот</li>
                       <li>Сразу после оплаты бот прислал вам Subscription Link</li>
                       <li>Перейдите в раздел 'Мои конфигурации'</li>
                       <li>Откройте 'Общая подписка'</li>
                       <li>Кликните один раз на ссылку, чтобы ее скопировать</li>
                       <li>Вы также можете воспользоваться QR кодом</li>
                     </ol>
                     <div className="step-screenshot">
                       <img src="/assets/get_link.jpg" alt="Скриншот: Получение ключа" />
                     </div>
                   </div>
                 </div>
               </div>

               <div className="setup-section">
                 <button
                   className={`section-header ${activeIndex === 1 ? 'active' : ''}`}
                   onClick={() => toggleSection(1)}
                 >
                   <h3>Установка и настройка V2RayA</h3>
                   <span className="section-icon">
                     {activeIndex === 1 ? '−' : '+'}
                   </span>
                 </button>
                 
                 <div className={`section-content ${activeIndex === 1 ? 'active' : ''}`}>
                   <div className="section-content-inner">
                     <ol className="steps-list">
                       <li>Для Ubuntu/Debian: Скачайте .deb пакет V2RayA с GitHub</li>
                       <li>Установите: sudo dpkg -i v2raya*.deb</li>
                       <li>Установите V2Ray Core: sudo apt install v2ray</li>
                       <li>Запустите сервис: sudo systemctl start v2raya</li>
                       <li>Включите автозапуск: sudo systemctl enable v2raya</li>
                       <li>Откройте браузер: http://127.0.0.1:2017</li>
                       <li>Создайте админа и импортируйте subscription-ссылку</li>
                     </ol>
                   </div>
                 </div>
               </div>

               <div className="tab-text-content">
                 <h1>Важные настройки V2RayA</h1>
                 <p>В веб-интерфейсе обязательно включите "Прозрачный прокси" для автоматической маршрутизации всего системного трафика через VPN. Без этого будет работать только в браузере.</p>
                 <p>В настройках "Routing" выберите "GeoIP разделение" чтобы российские сайты шли напрямую. В разделе "DNS" установите DoH: https://1.1.1.1/dns-query для обхода DNS блокировок.</p>
                 <p>V2RayA идеален для серверов - работает без GUI, управляется удаленно через браузер.</p>
               </div>
             </>
           )}

         </div>
       </div>
     </section>
     <Footer />
   </div>
 );
};

export default SetupLinuxPage;